import { render, staticRenderFns } from "./App-List.vue?vue&type=template&id=41cd65be&scoped=true&"
import script from "./App-List.vue?vue&type=script&lang=js&"
export * from "./App-List.vue?vue&type=script&lang=js&"
import style0 from "./App-List.vue?vue&type=style&index=0&id=41cd65be&scoped=true&lang=css&"
import style1 from "./App-List.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd65be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41cd65be')) {
      api.createRecord('41cd65be', component.options)
    } else {
      api.reload('41cd65be', component.options)
    }
    module.hot.accept("./App-List.vue?vue&type=template&id=41cd65be&scoped=true&", function () {
      api.rerender('41cd65be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/saas/layout/App-List.vue"
export default component.exports